/**
 * DESIGN.md „Fișă": structure comes from typographic rules, never from boxed
 * cards or shadows. A section is a 12px/600 uppercase label closed by a 2px
 * ink rule — the same grammar as the page title row, one level down.
 */
export function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-10">
      <h2 className="mb-3 border-b-2 border-ink pb-2 text-[12px] font-semibold uppercase tracking-[0.05em] text-ink-2">
        {title}
      </h2>
      {children}
    </section>
  );
}
